/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu, Jul 15th 2021, 9:53:14 pm
 *
 * *****************************************************
 */

import React from 'react';

import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { AppProvider } from '@shopify/polaris';
import { LinkLikeComponent } from '@shopify/polaris/dist/types/latest/src/utilities/link';
import enTranslations from '@shopify/polaris/locales/en.json';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import App from 'App';
import CustomPolarisLink from 'features/common/views/components/CustomPolarisLink';
import GoogleReCaptchaV3Provider from 'features/common/views/components/GoogleReCaptchaV3Provider';
import store from 'states/store';

import reportWebVitals from './reportWebVitals';
import GlobalStyle from './styles';
import '@shopify/polaris/dist/styles.css';
import './index.css';

const REACT_APP_ENV = process.env.REACT_APP_ENV!;

const listSupportedEnvironmentForSentry: string[] = ['staging', 'production'];
if (listSupportedEnvironmentForSentry.includes(REACT_APP_ENV)) {
  Sentry.init({
    dsn: 'https://447a0cf9c02c4e3cbae04f0ce3254f55@o877112.ingest.sentry.io/5980551',
    integrations: [new Integrations.BrowserTracing()],
    environment: process.env.REACT_APP_ENV,
    tracesSampleRate: 1.0
  });
}

ReactDOM.render(
  <Provider store={store}>
    <AppProvider i18n={enTranslations} linkComponent={CustomPolarisLink as LinkLikeComponent}>
      <GoogleReCaptchaV3Provider>
        <GlobalStyle />
        <Router>
          <App />
        </Router>
      </GoogleReCaptchaV3Provider>
    </AppProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
